export enum TERM_LENGTH_FORMAT {
  abv = 'abv',
  hyphen = 'hyphen',
  full_term = 'full_term',
}
